import { render, staticRenderFns } from "./BusinessUnitsDashboard.vue?vue&type=template&id=79fcb6c4&scoped=true&"
import script from "./BusinessUnitsDashboard.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fcb6c4",
  null
  
)

export default component.exports